import { render, staticRenderFns } from "./TeamContactInformation.vue?vue&type=template&id=06d19061&"
import script from "./TeamContactInformation.vue?vue&type=script&lang=js&"
export * from "./TeamContactInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports